import twMerge from 'twMerge';

import Button from 'molecules/Button';
import Image from 'molecules/Image';
import Section from 'molecules/Section';

import richTextParser from 'utils/richTextParser/richTextParser';

import type { ButtonProps } from 'molecules/Button';
import type { ImageData } from 'molecules/Image';
import type { SectionProps } from 'molecules/Section';

type BacksawProps = {
  author?: {
    name?: string;
    thumbnail?: { file?: { url?: string } };
  };
  background?: SectionProps['background'];
  body?: { raw?: string };
  buttons?: ButtonProps[];
  contentful_id?: string;
  heading?: string;
  padding?: string;
  quote?: { raw?: string };
  reverse?: boolean;
  sectionIdLink?: string;
};

const Backsaw = ({
  author,
  background,
  body,
  buttons,
  contentful_id,
  heading,
  padding,
  quote,
  reverse,
  sectionIdLink,
}: BacksawProps) => {
  const authorImage = author?.thumbnail;
  const authorTitle = `${author?.name}${author?.title ? `, ${author?.title}` : ''}`;

  return (
    <Section
      id={sectionIdLink}
      background={background}
      padding={padding}
      contained={false}
      contentfulId={contentful_id}
    >
      <div
        className={twMerge(
          'backsaw flex flex-col gap-12 md:gap-28 items-center',
          reverse ? 'md:flex-row-reverse' : 'md:flex-row',
        )}
      >
        <div className="flex w-full flex-col md:w-[267px] ">
          <div className="hidden h-px w-full bg-[#949596] md:block" />
          {heading && <h1 className="text-display-lg font-semibold md:mt-8 md:text-display-xl">{heading}</h1>}
          {body && (
            <div className="[&>*]:text-display-2xs mt-3 md:mt-4 [&>*]:font-semibold">
              {richTextParser(body as RichText)}
            </div>
          )}
        </div>
        <div className="flex-1">
          {authorImage && (
            <div className="size-[80px] md:size-[130px]">
              <Image
                image={authorImage as ImageData}
                alt={authorImage.title || ''}
                className="size-full rounded-full object-cover"
              />
            </div>
          )}
          {quote && (
            <div className="mt-8 [&>*]:text-md [&>*]:font-normal md:[&>*]:text-xl">
              {richTextParser(quote as RichText)}
            </div>
          )}
          {authorTitle && (
            <div className="mt-4 text-sm md:text-md">
              <p>{authorTitle}</p>
            </div>
          )}
          {buttons && (
            <div className="mt-8 text-xl md:mt-10">
              {buttons?.map(button => <Button {...(button as ButtonProps)} key={button?.internalName} />)}
            </div>
          )}
        </div>
      </div>
    </Section>
  );
};

export default Backsaw;
